import { tv } from "tailwind-variants"

export const insetBorderVariants = tv({
  variants: {
    positioning: {
      default: "",
      fixed: "before:fixed",
      absolute: "before:absolute",
    },
  },
  defaultVariants: {
    positioning: "default",
  },
  compoundVariants: [
    // Default positioning
    {
      positioning: "default",
      className: "inset-shadow-border",
    },
    // Fixed and absolute positioning
    {
      positioning: ["fixed", "absolute"],
      className:
        "before:pointer-events-none before:inset-0 before:inset-shadow-border before:z-inset-border before:rounded-inherit",
    },
    // Fixed positioning
    {
      positioning: "fixed",
      className: "fixed:inset-shadow-border",
    },
    // Fixed positioning
    {
      positioning: "absolute",
      className: "absolute:inset-shadow-border",
    },
  ],
})
